import { enumBoxWidthMode } from "../constants";

export function StringCodeToHSizingMode(strCode) {
  switch (strCode) {
    case "autoself":
      return enumBoxWidthMode.autoself;
    case "autosmart":
      return enumBoxWidthMode.autosmart;
    case "autochildren":
      return enumBoxWidthMode.autochildren;
    default:
      return enumBoxWidthMode.fixedwidth;
  }
}
